module.exports = __webpack_public_path__ + "media/images/etyekilogo-etyeki-76x76-403239324a93e70877cde44673154e95.png";